"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FiltersSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M6,16a1,1,0,0,0-1,1V29a1,1,0,0,0,2,0V17A1,1,0,0,0,6,16Z"/><path d="M9,11H7V3A1,1,0,0,0,5,3v8H3a1,1,0,0,0,0,2H9a1,1,0,1,0,0-2Z"/><path d="M16,17a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V16A1,1,0,0,0,16,17Z"/><path d="M19,20H13a1,1,0,0,0,0,2h2v7a1,1,0,0,0,2,0V22h2a1,1,0,0,0,0-2Z"/><path d="M26,16a1,1,0,0,0-1,1V29a1,1,0,1,0,2,0V17A1,1,0,0,0,26,16Z"/><path d="M29,11H27V3a1,1,0,0,0-2,0v8H23a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"/>';
var FiltersSVG = function FiltersSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FiltersSVG = FiltersSVG;
FiltersSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FiltersSVG);
exports.default = _default;